import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

export const HeadSkeleton = () => {
  return (
    <Box className={styles['head-skeleton__container']}>
      <SkeletonComponent height="22px" width="130px" mb="8px" />
      <SkeletonComponent height="22px" width="20px" mb="8px" />
      <SkeletonComponent height="22px" width="130px" mb="8px" />
    </Box>
  );
};

export const FilterSkeleton = () => {
  return (
    <Box className={styles['filter-skeleton__container']}>
      <Box className={styles['filter-skeleton__field-wrapper']}>
        <SkeletonComponent height="34px" width="377px" />
        <SkeletonComponent height="34px" width="168px" />
      </Box>
      <Box>
        <SkeletonComponent height="40px" width="98px" />
      </Box>
    </Box>
  );
};

export const TableSkeleton = () => {
  return (
    <Box data-testid="table-report-skeleton">
      <Table>
        <Thead>
          <Tr>
            <Th className={styles['skeleton__head']} minWidth="150px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="154px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="163px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="220px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="170px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="220px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="170px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
            <Th className={styles['skeleton__head']} minWidth="100px">
              <Flex justifyContent={'space-between'}>
                <SkeletonComponent height="18px" width="60%" />
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          <Iteration
            items={[1, 2, 3, 4, 5, 6, 7, 8]}
            render={(num) => {
              return (
                <Tr key={num}>
                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="90%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="80%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>

                  <Td className={styles['skeleton__column']}>
                    <SkeletonComponent height="18px" width="50%" mb="2px" />
                  </Td>
                </Tr>
              );
            }}
          />
        </Tbody>
      </Table>
    </Box>
  );
};
